/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import BaseObject from "@shared/BaseObject.js";

export default class OptionItem extends BaseObject {

	value = null
	label: string = ""
	options = {}


	constructor(value = null, label = "", options = {}) {
		super();
		this.value = value;
		this.label = label;
		this.options = options
	}
}
